import { Component } from '@angular/core';

@Component({
  selector: 'app-visibility-dashboard',
  templateUrl: './visibility-dashboard.component.html',
})
export class VisibilityDashboardComponent {}
